export default "__VITE_ASSET__DQgefjMG__"